export default __webpack_public_path__ + "media/images/lp/payment-pc-13cb447f946657a9bb7589914f135ed3.jpg";